/**
 * Normalise un libellé transaction pour détecter les récurrences.
 * Réplique exacte de src/backend/src/services/normalize.service.js.
 *   - lowercase
 *   - NFD unaccent
 *   - retire les chiffres
 *   - garde uniquement les lettres, collapse les autres chars en espace
 *   - tokenize + prend les 3 premiers mots significatifs
 *
 * @param {string} raw
 * @returns {string}
 */
export function normalizeLabel(raw) {
  return String(raw ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[0-9]/g, '')
    .replace(/[^a-z]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean)
    .slice(0, 3)
    .join(' ');
}
